
import React from 'react';

export const CompanyIcon: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`material-symbols-outlined ${className}`}>
    corporate_fare
  </span>
);